'use strict';

/**
 * @ngdoc directive
 * @name v-tv-package-sort
 *
 * @description
 * #directive
 * Display filter to sort channels (Not currently use in v-tv-package)
 *
 * @template:'<div class="sort-options"><div class="options-group"><span class="option-group-label">Trier par&nbsp;:</span> <button type="button" data-ng-hide="$ctrl.alphaSort" data-ng-click="$ctrl.sortAlpha(false)">A-Z</button> <button type="button" data-ng-hide="!$ctrl.alphaSort" data-ng-click="$ctrl.sortAlpha(true)">Z-A</button></div></div>'
 */

angular.module('v-tv-package').component('vTvPackageSort', {

    require: {
        channelsCtrl: '^vTvPackageChannels'
    },
    controller: function controller($scope, $filter) {
        var _this = this;

        this.alphaSort = false;

        this.$onInit = function () {
            $scope.$watchCollection('$ctrl.channelsCtrl.channelsList', function () {
                return _this.sortAlpha(false);
            });
        };

        this.sortAlpha = function (reverse) {
            _this.alphaSort = !reverse;
            if (_this.channelsCtrl.channelsList) {
                for (var catIndex = 0; catIndex < _this.channelsCtrl.channelsList.length; catIndex++) {
                    _this.channelsCtrl.channelsList[catIndex].channels = $filter('orderBy')(_this.channelsCtrl.channelsList[catIndex].channels, 'name', reverse);
                }
            }
        };
    },
    template:'<div class="sort-options"><div class="options-group"><span class="option-group-label">Trier par&nbsp;:</span> <button type="button" data-ng-hide="$ctrl.alphaSort" data-ng-click="$ctrl.sortAlpha(false)">A-Z</button> <button type="button" data-ng-hide="!$ctrl.alphaSort" data-ng-click="$ctrl.sortAlpha(true)">Z-A</button></div></div>'
});